<template>
<div class="popup-back">
    <div class="popup-box notiwidth">
        <p class="noti-title">{{ notice.title }}</p>
        <p class="noti-date">{{ convertDate(notice.date) }}</p>
        <p class="noti-text">{{ notice.text }}</p>
        <button v-on:click="close" class="close-btn">닫기</button>
    </div>
</div>    
</template>
<script>
import dateMix from './mixin/date';

export default {
    name: 'Noticepopup',
    mixins: [dateMix],
    props: [
        'notice'
    ],
    methods: {
        close() {
            this.$emit('onClose', '');
        }
    }
}
</script>
<style>
@import url(./assets/css/popup.css);
.noti-title {
    font-weight: 600;
    font-size: 17px;
}
.noti-date {
    font-weight: 400;
    text-align: right;
    font-size: 14px;
}
.noti-text {
    white-space: pre-wrap;
    text-align: left;
    padding-top: 30px;
    line-height: 1.5;
}
.notiwidth {
    width: 600px;
}

@media screen and (max-width: 414px) {
    .notiwidth {
        width: 90vw;
    }
}
</style>